export default {
  picks: {
    title: "My Picks",
    actions: {
      selectLocation: "Select a location",
      importPhoto: "Import photo",
      takePhoto: "Take photo",
      selectOperatorToContinue: "Select operator to continue",
      openOn: "Open on {{operator}}",
      visit: "Visit {{operator}}",
    },
    locationGate: {
      title: "Allow Linemate to access your location to use My Picks",
      subtitle: "Linemate uses your location to show markets and offers available in your area.",
    },
    empty: {
      title: "No picks yet",
      subtitle: "Tap into any trend to add them, or just share a photo and we will grab the picks for you.",
    },
    imageImport: {
      title: "Import Picks",
      scanningBetslip: "Scanning your betslip...",
      analyzingImage: "Analyzing your image...",
      detectingOdds: "Detecting odds",
      failed: "Failed to import picks",
      pleaseTryAgain: "Please try again",
      tryAgain: "Try again",
    },
    labels: {
      parlay: "Parlay",
      sgp: "SGP",
      straight: "Straight",
      legParlay: "{{count}}-Leg Parlay",
      pricingUnavailable: "Pricing not available",
      continueToOperator: "Continue to your operator",
    },
    sections: {
      availableOrAdjusted: "All props available or adjusted",
      missingProps: "Missing props",
      unavailableInRegion: "Not available in your region",
    },
    warnings: {
      legsNotFound_one: "{{count}} leg could not be found",
      legsNotFound_other: "{{count}} legs could not be found",
      adjusted_one: "{{count}} leg was adjusted",
      adjusted_other: "{{count}} legs were adjusted",
      and: " and ",
      forOperator: " for {{operator}}.",
    },
  },
};